import React, {useMemo, useState} from 'react';
import {FacetGroupTitle} from './FacetGroupTitle/FacetGroupTitle';
import FacetGroupContent from './FacetGroupContent/FacetGroupContent';
import {FacetValue, FacetValuesSortOrder, HibuFacetGroup, RANGE} from '../../facet.types';
import {useIsFilterGroupExpanded, useSort} from '../../duck/filter.hooks';
import {ListGroupItem} from 'react-bootstrap';

type InputProps = {
    group: HibuFacetGroup;
};

const sortComparators: Record<FacetValuesSortOrder, (a: FacetValue, b: FacetValue) => number> = {
    [FacetValuesSortOrder.COUNT]: (a: FacetValue, b: FacetValue) => {
        return b.count - a.count;
    },
    [FacetValuesSortOrder.NAME]: (a: FacetValue, b: FacetValue) => {
        return a.name.localeCompare(b.name);
    },
    [FacetValuesSortOrder.VALUE]: (a: FacetValue, b: FacetValue) => {
        return a.value.localeCompare(b.value);
    },
};

export const FacetGroup = React.memo(({group}: InputProps) => {
    const sort: FacetValuesSortOrder = useSort();
    const isExpanded: boolean = useIsFilterGroupExpanded(group.fieldName);

    const [searchTerm, setSearchTerm] = useState<string>('');

    const sortedAndFilteredValues: FacetValue[] = useMemo(() => {
        if (group.values.length <= 0 || group.values[0].filter.type === 'range') {
            return group.values;
        }
        const actualSort = group.fieldName.endsWith('_dirPath') ?
            FacetValuesSortOrder.VALUE :
            sort;
        const sortedValues: FacetValue[] = group.values.toSorted(sortComparators[actualSort]);

        //filter sortedValues based on searchTerm
        return sortedValues.filter((elem) => {
            return elem.name.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }, [group.fieldName, group.values, searchTerm, sort]);

    return (
        <ListGroupItem key={group.fieldName} className={isExpanded ? '' : 'collapsed'}>
            <FacetGroupTitle fieldName={group.fieldName} isExpanded={isExpanded}
                             isSearchable={group.values[0].filter.type !== RANGE} searchTerm={searchTerm}
                             setSearchTerm={setSearchTerm}></FacetGroupTitle>
            <FacetGroupContent sortedValues={sortedAndFilteredValues} fieldName={group.fieldName}
                               errorCode={group.errorCode}
                               isExpanded={isExpanded}></FacetGroupContent>
        </ListGroupItem>
    );
});
